import * as React from 'react';

function SvgRecommendedUniversity(props) {
  return (
    <svg height={11} width={15} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.5 1.16L1.947 3.626 7.5 6.092l5.553-2.466zM7.743.051l6.923 3.075a.542.542 0 010 1.001L12.23 5.208v3.616a.55.55 0 01-.358.51L7.718 10.96a.6.6 0 01-.437 0L3.128 9.335a.553.553 0 01-.359-.511V5.208L.334 4.127a.542.542 0 010-1.001L7.257.051a.604.604 0 01.486 0zm3.333 5.669L7.743 7.201a.596.596 0 01-.486 0l-3.334-1.48v2.732L7.5 9.852l3.577-1.399z" />
    </svg>
  );
}

export default SvgRecommendedUniversity;
